import { useState, useEffect } from "react"; 
import { Download, FileText, Upload, Trash2 } from "lucide-react";
import LecturerSidebar from "../components/LecturerSidebar.js";
import FileUploadModal from "../components/FileUploadModal.js";
import axios from "axios";
import "../styles/LecturerMaterials.css";
import { encodePathSegment } from "../utils/apiPath";

export default function LecturerMaterials() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [materials, setMaterials] = useState([]);

  const fetchMaterials = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/materials/lecturer`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setMaterials(res.data);
    } catch (err) {
      console.error("Błąd pobierania materiałów", err);
    }
  };

  useEffect(() => {
    fetchMaterials();
  }, []);

  const handleDeleteMaterial = async (groupCode, moduleId, fileName) => {
    if (!window.confirm(`Czy na pewno chcesz usunąć plik "${fileName}"?`)) {
      return;
    }

    try {
      const encodedGroup = encodePathSegment(groupCode);
      const encodedFileName = encodeURIComponent(fileName);
      
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/materials/delete/${encodedGroup}/${moduleId}/${encodedFileName}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      // Refresh the materials list
      fetchMaterials();
    } catch (err) {
      console.error("Błąd usuwania materiału", err);
      alert(err.response?.data?.message || "Wystąpił błąd podczas usuwania pliku. Spróbuj ponownie.");
    }
  };

  return (
    <div className="lecture-dashboard-panel">
      <LecturerSidebar />
      <div className="main-content">
        <div className="header">
          <h1 className="header-title">Materiały</h1>
        </div>

        <div className="dashboard">
          <h2 className="page-title">Materiały</h2>
          <p className="page-subtitle">Zasoby edukacyjne i dokumenty</p>

          {/* Karta dodawania pliku */}
          <div className="grades-card">
            <div className="grades-card-content">
              <h3>Pliki i dokumenty</h3>
              <button
                className="btn button-primary"
                onClick={() => setIsModalOpen(true)}
              >
                <Upload size={16} style={{ marginRight: "0.5rem" }} />
                Dodaj plik
              </button>
            </div>
            {/* File list */}
            <div className="file-list-grid file-grid-cols-3">
                {materials.length === 0 && <p>Brak materiałów</p>}
                {materials.map(({ module, files }) =>
                    files.map((file, idx) => (
                        <div key={`${module.group_code}-${module.module_id}-${idx}`} className="file-card">
                            <div className="file-icon">
                                <FileText size={20} color="#16a34a" />
                                <span className="file-extension">
                                    {file.name.split('.').pop().toUpperCase()}
                                </span>
                            </div>
                            <h2 className="file-module">
                              {module.module_name}
                              {module.group_name ? ` — ${module.group_name}` : ""}
                            </h2>
                            <h4 className="file-name">{file.name}</h4>
                            <p className="file-size">{(file.size / (1024 * 1024)).toFixed(2)} MB</p>
                            <div className="file-actions">
                              <button
                                className="btn button-secondary button-download"
                                onClick={() => {
                                  const encodedGroup = encodePathSegment(module.group_code);
                                  const encodedFileName = encodeURIComponent(file.name);
                                  const url = `${process.env.REACT_APP_API_URL}/materials/download/${encodedGroup}/${module.module_id}/${encodedFileName}`;
                                  const link = document.createElement('a');
                                  link.href = url;
                                  link.setAttribute('download', file.name);
                                  document.body.appendChild(link);
                                  link.click();
                                  link.remove();
                                }}
                              >
                                <Download size={14} style={{ marginRight: "0.5rem" }} />
                                Pobierz
                              </button>
                              <button
                                className="btn button-delete"
                                onClick={() => handleDeleteMaterial(module.group_code, module.module_id, file.name)}
                                title="Usuń plik"
                              >
                                <Trash2 size={14} style={{ marginRight: "0.5rem" }} />
                                Usuń
                              </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <FileUploadModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          fetchMaterials(); // Refresh materials after closing modal
        }}
      />
    </div>
  );
}
